var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoungeZone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 104,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m67.162 73.43-33.68.082-24.69 15.554 80.605-3.994L67.162 73.43Z",
    fill: "#FFC239",
    stroke: "#0D0D0D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m68 59.5 15.5-7-3-10.5L63 30.5l5 29ZM38 34.5l-3.5 7 4.5 8 24-19s-19 2.5-25 4Z",
    fill: "#FFC239"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m63 30.5-24 19 16.259 8.081 2.72.755L68 59.5l-5-29ZM83.5 52.5l-15.5 7v3l15.5-7v-3Z",
    fill: "#FFC239"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.242 61.222 68 62.5v-3l-10.022-1.164-.736 2.886ZM57.978 58.336l-2.72-.755-.758 2.92 2.742.72.736-2.885Z",
    fill: "#FFC239"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m39 49.5-1 3 16.5 8 .759-2.919L39 49.501Z",
    fill: "#FFC239"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m39 49.5-4.5-8-1 3 4.5 8 1-3ZM51.5 81h3l2.742-19.778L54.5 60.5l-3 20.5Z",
    fill: "#FFC239"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M63 30.5 80.5 42l3 10.5M63 30.5s-19 2.5-25 4l-3.5 7m28.5-11-24 19m24-19 5 29m-5-29-28.5 11m28.5-11 20.5 22m-44.5-3-4.5-8m4.5 8-1 3m1-3 16.259 8.081M68 59.5l15.5-7m-15.5 7v3m0-3-10.022-1.164M34.5 41.5l-1 3 4.5 8m45.5 0v3l-15.5 7m-30-10 16.5 8m13.5 2-10.758-1.278m-1.983-3.64 2.72.754m-2.72-.755-.759 2.92m3.478-2.165-.736 2.886m0 0L54.5 81h-3l3-20.5m2.742.722L54.5 60.5",
    stroke: "#0D0D0D",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoungeZone);
export default __webpack_public_path__ + "static/media/lounge-zone.13c6e3d9ed69a0524131a6a10c45ea52.svg";
export { ForwardRef as ReactComponent };